import { SubscriptionFinalStatus, SubscriptionStatus, SubscriptionType } from '../enums/common.enums';

export default class SubscriptionHelper {
  static getSubscriptionFinalStatus(
    subscriptionStatusId?: SubscriptionStatus,
    subscriptionType?: SubscriptionType | null,
    subscriptionEndDate?: Date
  ): SubscriptionFinalStatus {
    if (subscriptionType == null) {
      return SubscriptionFinalStatus.NotSubscribed;
    } else if (
      (subscriptionStatusId == SubscriptionStatus.Canceled || !subscriptionEndDate) &&
      subscriptionType != SubscriptionType.PayPerUse
    ) {
      return SubscriptionFinalStatus.Expired;
    } else if (
      (subscriptionStatusId == SubscriptionStatus.PastDue || subscriptionStatusId == SubscriptionStatus.Unpaid) &&
      subscriptionType != SubscriptionType.PayPerUse
    ) {
      return SubscriptionFinalStatus.Overdue;
    } else if (subscriptionType == SubscriptionType.PayPerUse) {
      return SubscriptionFinalStatus.PayPerUse;
    } else {
      return SubscriptionFinalStatus.Active;
    }
  }

  private static statusClassMap: Record<number, string> = {
    0: 'status-not-subscribed',
    1: 'status-expired',
    2: 'status-overdue',
    3: 'status-pay-per-use',
    4: 'status-active',
  };

  static getStatusClass(statusId: number): string {
    return this.statusClassMap[statusId] || '';
  }

  private static statusIconMap: Record<number, string> = {
    0: 'icon-info',
    1: 'icon-warn',
    2: 'icon-warn',
    3: 'icon-checked',
    4: 'icon-charge',
  };

  static getStatusIcon(statusId: number): string {
    return this.statusIconMap[statusId] || '';
  }

  private static statusButtonMap: Record<number, string> = {
    0: 'critical-button',
    1: 'critical-button',
    2: 'critical-button',
    3: 'hollow-button',
    4: 'hollow-button',
  };

  static getStatusButton(statusId: number): string {
    return this.statusButtonMap[statusId] || '';
  }
}
